import styled from "styled-components";

export const Note = styled.div`
  text-align: center;
  font-size: 1rem;
`